import { render } from "./FireLogin.vue?vue&type=template&id=3225bb31"
import script from "./FireLogin.vue?vue&type=script&lang=ts"
export * from "./FireLogin.vue?vue&type=script&lang=ts"
script.render = render

export default script